import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="bg-[#0a0a0a] py-16 px-4 border-t-4 border-[#FFD700] scroll-mt-10" data-id="element-82">
      <div className="max-w-6xl mx-auto" data-id="element-83">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-84">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-85">
            💎 Valor total del paquete
          </h3>
          <p className="text-xl text-white/50 line-through mb-2" data-id="element-86">
            💰 Valor total: $149.990 ARS
          </p>
          <div className="inline-block bg-red-600/20 text-red-400 font-bold px-4 py-1 rounded-full text-sm border border-red-500/30 mb-3" data-id="element-87">
            ⚡ Hoy podés acceder por el precio de lanzamiento
          </div>
          <p className="text-sm text-[#c4b5d4] mt-2" data-id="element-88">
            Opcional a la compra:{' '}
            <span className="text-white font-semibold" data-id="element-89">
              CHATBOTS PARA WHATSAPP CON IA
            </span>{' '}
            y{' '}
            <span className="text-white font-semibold" data-id="element-90">
              CREACIÓN DE EBOOK CON IA
            </span>
          </p>
        </motion.div>

        {/* 3-Column Pricing Grid — Compact */}
        <div className="flex flex-col gap-3 mb-8" data-id="element-91">
          {/* CARD 1 — $19.990 CURSO COMPLETO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="relative bg-[#111] border-2 border-[#FFD700] rounded-xl p-4 shadow-[0_0_30px_rgba(255,215,0,0.15)] flex flex-col" data-id="element-92">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#FFD700] text-black text-[10px] font-black px-4 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-93">
              ⭐ Más Popular
            </div>

            <h4 className="text-lg font-black text-[#FFD700] mt-3 mb-0.5 text-center leading-tight" data-id="element-94">
              DOMINÁ LA INTELIGENCIA ARTIFICIAL
            </h4>
            <p className="text-xs text-white/70 font-bold mb-3 text-center" data-id="element-95">
              Curso Completo
            </p>

            <ul className="space-y-1.5 mb-4 text-xs text-[#c4b5d4] flex-1" data-id="element-96">
              <li className="flex items-center gap-1.5" data-id="element-97">
                <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-98" />{' '}
                13 clases prácticas en video
              </li>
              <li className="flex items-center gap-1.5" data-id="element-99">
                <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-100" />{' '}
                Curso completo
              </li>
              <li className="flex items-center gap-1.5" data-id="element-101">
                <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-102" />{' '}
                3 bonos especiales
              </li>
              <li className="flex items-center gap-1.5" data-id="element-103">
                <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-104" />{' '}
                Acceso inmediato y de por vida
              </li>
              <li className="flex items-center gap-1.5" data-id="element-105">
                <ShieldCheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-106" />{' '}
                Pago seguro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-107">
                <CheckIcon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-108" />{' '}
                Mercado Pago
              </li>
            </ul>

            <div className="text-center mb-3" data-id="element-109">
              <p className="text-xs text-white/40 line-through" data-id="element-110">$47.000 ARS</p>
              <div className="flex justify-center items-baseline gap-1" data-id="element-111">
                <span className="text-4xl font-black text-[#FFD700] drop-shadow-[0_0_15px_rgba(255,215,0,0.3)]" data-id="element-112">
                  $19.990
                </span>
                <span className="text-sm text-[#FFD700] font-bold" data-id="element-113">ARS</span>
              </div>
            </div>

            <a href="https://checkout.impulsodigitalx.shop/cart/45833808838817:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#FFD700] hover:bg-[#FFC107] text-black font-black text-base py-3 px-3 rounded-lg shadow-[0_0_30px_rgba(255,215,0,0.4)] transition-all text-center uppercase tracking-wide border-b-4 border-yellow-600 active:border-b-0 active:translate-y-1 animate-pulse" data-id="element-114">
              ACCEDER AHORA
            </a>
          </motion.div>

          {/* CARD 2 — $29.990 COMBO PRO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-gradient-to-b from-red-950/30 to-[#111] border-2 border-red-900/50 rounded-xl p-4 flex flex-col" data-id="element-115">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red-600 text-white text-[10px] font-bold px-4 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-116">
              🔥 Combo Perfecto
            </div>

            <div className="bg-red-600/20 border border-red-500/30 rounded-lg px-3 py-2 mt-3 mb-1" data-id="element-117">
              <h4 className="text-base font-black text-white text-center leading-tight" data-id="element-118">
                CHATBOTS PARA WHATSAPP CON IA
              </h4>
            </div>
            <p className="text-xs text-[#FFD700] font-bold mb-3 text-center" data-id="element-119">
              🔥 Pro
            </p>

            <ul className="space-y-1.5 mb-4 text-xs text-[#c4b5d4] flex-1" data-id="element-120">
              {['Todo del Curso Completo', '3 bonos especiales', 'Responder clientes automáticamente', 'Automatizar atención al cliente', 'Generar leads', 'Responder preguntas frecuentes', 'Mejorar ventas'].map((item, i) => <li key={i} className="flex items-center gap-1.5" data-id="element-121">
                  <CheckIcon className={`w-3.5 h-3.5 flex-shrink-0 ${i === 0 ? 'text-[#FFD700]' : 'text-green-500'}`} data-id="element-122" />
                  <span className={i === 0 ? 'text-[#FFD700] font-semibold' : ''} data-id="element-123">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="text-center mb-3" data-id="element-124">
              <div className="flex justify-center items-baseline gap-1" data-id="element-125">
                <span className="text-4xl font-black text-white" data-id="element-126">$29.990</span>
                <span className="text-sm text-white font-bold" data-id="element-127">ARS</span>
              </div>
            </div>

            <a href="https://checkout.impulsodigitalx.shop/cart/45833816440993:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-500 text-white font-black text-base py-3 px-3 rounded-lg transition-colors text-center uppercase tracking-wide border-b-4 border-green-800 active:border-b-0 active:translate-y-1" data-id="element-128">
              AGREGAR COMBO PRO
            </a>
          </motion.div>

          {/* CARD 3 — $38.990 COMBO MASTER PRO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative bg-gradient-to-b from-purple-950/30 to-[#111] border-2 border-purple-900/50 rounded-xl p-4 flex flex-col" data-id="element-129">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-purple-600 text-white text-[10px] font-bold px-4 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-130">
              ⭐ Más Elegido
            </div>

            <div className="bg-purple-600/20 border border-purple-500/30 rounded-lg px-3 py-2 mt-3 mb-1" data-id="element-131">
              <h4 className="text-base font-black text-white text-center leading-tight" data-id="element-132">
                CREACIÓN DE EBOOK CON IA
              </h4>
            </div>
            <p className="text-xs text-[#FFD700] font-bold mb-3 text-center" data-id="element-133">
              Combo Master Pro
            </p>

            <ul className="space-y-1.5 mb-4 text-xs text-[#c4b5d4] flex-1" data-id="element-134">
              {['Todo del Curso Completo', '3 bonos especiales', 'Chatbots para WhatsApp con IA', 'Encontrar ideas rentables', 'Escribir capítulos con IA', 'Estructurar ebooks'].map((item, i) => <li key={i} className="flex items-center gap-1.5" data-id="element-135">
                  <CheckIcon className={`w-3.5 h-3.5 flex-shrink-0 ${i === 0 ? 'text-[#FFD700]' : 'text-green-500'}`} data-id="element-136" />
                  <span className={i === 0 ? 'text-[#FFD700] font-semibold' : ''} data-id="element-137">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="text-center mb-3" data-id="element-138">
              <div className="flex justify-center items-baseline gap-1" data-id="element-139">
                <span className="text-4xl font-black text-white" data-id="element-140">$38.990</span>
                <span className="text-sm text-white font-bold" data-id="element-141">ARS</span>
              </div>
            </div>

            <a href="https://checkout.impulsodigitalx.shop/cart/45833819652257:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-500 text-white font-black text-base py-3 px-3 rounded-lg transition-colors text-center uppercase tracking-wide border-b-4 border-green-800 active:border-b-0 active:translate-y-1" data-id="element-142">
              🔥 AGREGAR COMBO MASTER 🔥
            </a>
          </motion.div>
        </div>

        {/* Oferta exclusiva notice */}
        <div className="text-center p-4 bg-yellow-900/20 border border-yellow-700/30 rounded-lg" data-id="element-143">
          <h5 className="text-lg font-bold text-[#FFD700] mb-1" data-id="element-144">
            🎯 Oferta exclusiva
          </h5>
          <p className="text-sm text-[#c4b5d4]" data-id="element-145">
            Estas ofertas solo aparecen durante esta compra. Una vez finalizado
            el pedido no estarán disponibles a este precio.
          </p>
        </div>
      </div>
    </section>;
}